<script setup>
import Card from '@/components/Shared/Card.vue';
import {computed, inject, onBeforeMount, ref, watch} from 'vue';
import Multiselect from "vue-multiselect";
import {debounce} from "lodash";

const props = defineProps({
  ticket: {
    type: Object,
    required: true,
  },
  isCustomer: {
    type: Boolean,
    default: false,
  },
});

const trans = inject('trans');
const selectedUsersToNotify = ref([])

const userOrPartnerPicture = computed(() => {
  const defaultPicture = '/images/05.jpg';

  if (props.isCustomer) {
    return props.ticket.sendTo?.partner?.logoUrl ?? defaultPicture;
  }

  return props.ticket.sendTo?.user?.photoUrl ?? defaultPicture;
});

const userOrPartnerName = computed(() => {
  if (props.isCustomer) {
    return props.ticket.sendTo?.partner.companyName;
  }

  return props.ticket.user?.name || trans('__JSON__.User Deleted');
});

const handleUpdateUsersToNotify = debounce(() => {
  if (selectedUsersToNotify.value !== props.ticket.usersToNotify){
    axios.post(route('dashboard.support.ticket.updateUsersToNotify', {...props.ticket}),
      {usersToNotify: selectedUsersToNotify.value });
  }
}, 1000);

onBeforeMount(function () {
  selectedUsersToNotify.value = props.ticket.usersToNotify
})

watch([selectedUsersToNotify], () => {
  handleUpdateUsersToNotify()
});

</script>

<template>
  <card>
    <template #body>
      <div v-if="ticket.user">
        <div class="grid-2 gap">
          <div>
            <img :src="userOrPartnerPicture" alt="user logo" style="width: 70px; height: auto"/>
          </div>
          <div>
            <strong>{{ userOrPartnerName }}</strong>
          </div>
        </div>
      </div>
      <div v-else>
        <div class="color_danger">
          <strong>{{ trans('__JSON__.User Deleted') }}</strong>
        </div>
      </div>
      <div class="mt-4 mb-2">
        <strong>{{ trans('__JSON__.Ticket number') }}:</strong>
        <p>{{ ticket.id }}</p>
      </div>
      <div class="mt-4 mb-2">
        <strong>{{ trans('__JSON__.Created on') }}:</strong>
        <p>{{ moment(ticket.dateCreated).format('MMM DD, YYYY, h:mm:ss A') }}</p>
      </div>
      <div class="my-4">
        <strong>{{ trans('__JSON__.Support type') }}:</strong>
        <p>{{ ticket.type }}</p>
      </div>
      <div class="my-4">
        <strong>{{ trans('common.application') }} 1:</strong>
        <p>{{ ticket.application1.name }}</p>
      </div>
      <div v-if="ticket.application2?.name" class="my-4">
        <strong>{{ trans('common.application') }} 2:</strong>
        <p>{{ ticket.application2.name }}</p>
      </div>
      <div v-if="ticket.user" class="my-4">
        <strong>{{ trans('common.address') }}:</strong>
        <div>{{ ticket.user.address }} {{ ticket.user.address2 }}</div>
        <div>{{ ticket.user.zip }} {{ ticket.user.city }}</div>
        <div>{{ ticket.user.country }}</div>
      </div>
      <div v-if="ticket.user.teamMembers" class="my-4">
        <strong>{{ trans('__JSON__.Notify') }}:</strong>
        <div class="w-full space-y-2 md:px-8 @md/modal:px-8 md:w-full @md/modal:w-full">
          <div class="outl1ne-multiselect-field">
            <multiselect
              v-model="selectedUsersToNotify"
              :options="ticket.user.teamMembers"
              :multiple="true"
              :close-on-select="false"
              :clear-on-select="false"
              :allow-empty="false"
              label="name"
              track-by="id"
            />
          </div>
        </div>
      </div>
    </template>
  </card>
</template>
